import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import Broker from './item'
import { Carousel } from 'react-bootstrap'
import LazyLoad from 'react-lazyload';


export default class Brokers extends Component {

  render () {

    const { brokers, section } = this.props;

    let sectionClass = ((section === undefined) ? 'col-broker col-home' : 'col-broker')

    if (brokers.length == 0)
      return null

    var next = <i className="fa fa-angle-right fa-2x"></i>;
    var prev = <i className="fa fa-angle-left fa-2x"></i>;

    if (brokers) {
      return (
        <div className="brokers-container">
          {!this.props.title ? '' : (
            <h1>{this.props.title}</h1>
          )}
  
          <LazyLoad offset={450}>
            <div className="container-fluid container-fluid-brokers">
              { (section) ? (
                  <div className="text-center title-slide">Equipo {section}</div>
                ) : '' 
              }
  
              {(brokers && brokers.length > 0) ? (
                <Carousel nextIcon={next} prevIcon={prev} className="brokers-carousel visible-xs">
                  {brokers.map((item, index) =>
                    <Carousel.Item key={index+"carousel"}>
                      <Broker item={item} key={index} section={section} infoout={true} />
                    </Carousel.Item>
                  )}
                </Carousel>
              ) : ''}
  
              {(brokers && brokers.length > 0) ? (
                <div className="intro-wrapper hidden-xs">
                  {brokers.map((item, index) =>
                    <Col md={3} sm={6} xs={12} className={sectionClass} key={index}> 
                      <Broker item={item} key={index} section={section} />
                    </Col> 
                  )}
                </div>
              ) : ''}
  
  
            </div>
          </LazyLoad>
        </div>
      )
    }
    else {
      return <p>cargando..</p>
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Brokers/index.js